import { Loader2 } from "lucide-react";

export const field = "w-full bg-white border border-[#ddd4c7] rounded-lg px-3.5 py-2.5 text-[#14110F] text-[0.95rem] outline-none transition-colors duration-200 focus:border-[#8A6A3A] placeholder:text-[#9b9188]";

export const Field = ({ label, hint, children }) => (
  <label className="block">
    <span className="block text-[0.7rem] tracking-[0.16em] uppercase text-[#6b625a] mb-1.5">{label}</span>
    {children}
    {hint && <span className="block mt-1 text-xs text-[#6b625a]">{hint}</span>}
  </label>
);

export const Btn = ({ variant = "dark", loading, className = "", children, ...p }) => {
  const v = {
    dark: "bg-[#14110F] text-[#F6F2EC] hover:bg-[#8A6A3A]",
    gold: "bg-[#C9A66B] text-[#14110F] hover:bg-[#14110F] hover:text-[#F6F2EC]",
    ghost: "border border-[#ddd4c7] text-[#14110F] hover:border-[#8A6A3A] hover:text-[#8A6A3A]",
    danger: "border border-[#e3c4bd] text-[#9a3b2b] hover:bg-[#9a3b2b] hover:text-white",
  }[variant];
  return (
    <button type="button" disabled={loading || p.disabled} {...p}
      className={`inline-flex items-center justify-center gap-2 rounded-full px-4 py-2 text-[0.72rem] tracking-[0.14em] uppercase transition-colors duration-200 disabled:opacity-50 ${v} ${className}`}>
      {loading && <Loader2 className="w-3.5 h-3.5 animate-spin" />} {children}
    </button>
  );
};

export const Empty = ({ children, testId }) => (
  <div data-testid={testId} className="border border-dashed border-[#ddd4c7] rounded-xl p-10 text-center text-[#6b625a]">{children}</div>
);

export const Loading = () => (
  <div className="py-16 flex justify-center" data-testid="admin-loading"><Loader2 className="w-6 h-6 animate-spin text-[#8A6A3A]" /></div>
);

export const fmtDate = (d) => {
  if (!d) return "—";
  const x = new Date(d);
  return Number.isNaN(x.getTime()) ? d : x.toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
};

export const fmtDateTime = (d) => {
  const x = new Date(d);
  return Number.isNaN(x.getTime()) ? "—" : x.toLocaleString("it-IT", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
};

export const Pill = ({ tone = "neutral", children, testId }) => {
  const t = {
    neutral: "bg-[#efe9df] text-[#4f4841]",
    gold: "bg-[#f3e6cd] text-[#7a5a28]",
    green: "bg-[#e1efe3] text-[#2f6b3d]",
    red: "bg-[#f6e1dc] text-[#9a3b2b]",
  }[tone];
  return <span data-testid={testId} className={`inline-flex items-center rounded-full px-2.5 py-1 text-[0.68rem] tracking-[0.1em] uppercase ${t}`}>{children}</span>;
};

export const FilterBar = ({ value, onChange, options, testPrefix }) => (
  <div className="flex flex-wrap gap-2">
    {options.map(([k, label, n]) => (
      <button key={k} type="button" onClick={() => onChange(k)} data-testid={`${testPrefix}-${k}`}
        className={`rounded-full px-4 py-1.5 text-sm border transition-colors duration-200 ${value === k ? "bg-[#14110F] border-[#14110F] text-[#F6F2EC]" : "border-[#ddd4c7] text-[#4f4841] hover:border-[#8A6A3A]"}`}>
        {label}{n != null && <span className="ml-1.5 opacity-70">{n}</span>}
      </button>
    ))}
  </div>
);
